import BookingDetails from "./BookingDetails";
import './bookingDetails.scss';

export default BookingDetails;